import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Tier.List.IRequest;
type Response = Api.Core.Tier.List.IResponse;
type Headers = Api.Core.Tier.List.IHeaders;
const url = '/api/ProductManagement/Tier';
export default async function tierListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
